import { render } from "./branch-position-tree.vue?vue&type=template&id=5e65e617"
import script from "./branch-position-tree.vue?vue&type=script&lang=js"
export * from "./branch-position-tree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__